import { Controller } from "stimulus"
export default class extends Controller {
  static get targets(){
    return ['yay', 'nay', 'form'];
  }

  initialize(){
   }

  handleError(e){
    this.formTarget.innerHTML =  e.detail[2].response;
    this.nayTarget.play(); 
  }

  handleSuccess(e){
   this.formTarget.innerHTML =  e.detail[2].response;
    this.yayTarget.play(); 
  
  }

}




// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/locations_app_controller.js